export default __webpack_public_path__ + "static/media/Caret Left.6857af9d.svg";